import React from "react";
import { Music2, Apple, Youtube, Instagram, Facebook } from "lucide-react";
import { BAND } from "@/data/eiffel65";

const ITEMS = [
  { icon: Music2, label: "Spotify", href: `https://open.spotify.com/artist/${BAND.spotifyArtistId}`, color: "#1DB954" },
  { icon: Apple, label: "Apple Music", href: "https://music.apple.com/us/artist/eiffel-65/2706957", color: "#FFFFFF" },
  { icon: Youtube, label: "YouTube", href: "https://www.youtube.com/user/eiffel65", color: "#FF0000" },
  { icon: Instagram, label: "Instagram", href: "https://www.instagram.com/eiffel65official", color: "#E1306C" },
  { icon: Facebook, label: "Facebook", href: "https://www.facebook.com/eiffel65", color: "#1877F2" },
];

export default function SocialRail() {
  return (
    <div
      data-testid="social-rail"
      className="hidden xl:flex fixed right-5 top-1/2 -translate-y-1/2 z-30 flex-col items-center gap-3"
    >
      {ITEMS.map((it) => {
        const Icon = it.icon;
        return (
          <a
            key={it.label}
            href={it.href}
            target="_blank"
            rel="noreferrer"
            aria-label={it.label}
            data-testid={`social-${it.label.toLowerCase().replace(/\s+/g, "-")}`}
            className="group w-11 h-11 grid place-items-center rounded-full glass border border-white/10 text-white/70 hover:scale-110 hover:border-[#00AFFF]/60 hover:shadow-[0_0_18px_rgba(0,175,255,0.4)] transition-all"
            style={{ "--hover-color": it.color }}
          >
            <Icon
              size={16}
              className="transition-colors duration-200 group-hover:text-[var(--hover-color,#00AFFF)]"
            />
          </a>
        );
      })}
    </div>
  );
}
